import React from 'react';

export const Divider = ({ className = '' }) => (
   <svg className={`${className} fill-current`} viewBox="0 0 1440 140">
      <path d="M0,128L1440,32L1440,0L0,0Z" />
   </svg>
);
